import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Spinner, Card, Tabs, Tab, Badge } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import "../portal.scss";
import "~/assets/css/scrollbar.css";

import {
  redirectUserTo,
  getRequestsByUsername,
} from "~/store/ducks/portalrh/actionTypes";
import { RequestState } from "../TabsEnum";

import RequestItem from "../RequestItem";
import { PORTALRH_MIDDLEWARE } from "~/utils/constants";
import { useInterval } from "~/components/Notifications/utils/useInterval.js";

import { withNamespaces } from "react-i18next";
import CustomDropdown from "~/components/widgets/CustomDropdown";

const MyRequestsWidget = ({ apagarWidget, ...props }) => {
  const { t } = props;

  const { allMenus } = useSelector((state) => state.portalRhMenuReducer);

  const { user } = useSelector((state) => state.globalReducer);

  const usernamePortalRh = user.legacyUsers.find(
    (item) => item.legacyApplication.label === PORTALRH_MIDDLEWARE.context
  )?.username;

  const [requestState, setRequestState] = useState(RequestState.PENDING);

  let pendingRequestValues = useState([]);
  let approvedRequestValues = useState([]);
  let refusedRequestValues = useState([]);

  let pendingRequests = useState();
  let approvedRequests = useState();
  let refusedRequests = useState();

  let nPendingRequests = useState("");

  const dispatch = useDispatch();
  const history = useHistory();
  const { userSettings } = useSelector((state) => state.userSettingsReducer);
  const { pathToRedirect, requests, isLoadingRequests } = useSelector(
    (state) => state.portalrhReducer
  );

  useEffect(() => {
    dispatch(getRequestsByUsername(usernamePortalRh));
  }, []);

  useInterval(() => {
    dispatch(getRequestsByUsername(usernamePortalRh));
  }, 1000 * 60);

  /*Send Context to iframe*/
  useEffect(() => {
    if (pathToRedirect) {
      if (document.getElementById("portalrh")) {
        /*Display iframe*/
        document.getElementById("portalrh").style.display = "block";
      }

      const context = {
        theme: userSettings.theme ? userSettings.theme : "default",
        language: userSettings.language ? userSettings.language : "EN",
        location: "",
      };
      try {
        const object = JSON.parse(pathToRedirect);
        if (object.action && object.url) {
          history.push(`/uniksystem/portalrh/${object.url}`);
          context.location = object.action;
        }
      } catch (exception) {
        history.push(`/uniksystem/portalrh/${pathToRedirect}`);
        context.location = "fp_folha_ponto";
      }

      let event = new CustomEvent("UserContextEvent", { detail: context });
      if (document.getElementById("portalrh")) {
        if (document.getElementById("portalrh").contentWindow) {
          document
            .getElementById("portalrh")
            .contentWindow.dispatchEvent(event);
        }
      }
    }

    return () => {
      dispatch(redirectUserTo(""));
    };
  }, [pathToRedirect]);

  const processRequests = (state) => {
    const requestsByState = requests.filter(
      (request) => request.state === state && request.authorizer_approves === -1
    );

    let descriptions = [];
    let quantities = [];
    let flowId = {};

    let countValidRequests = 0;

    for (let i = 0; i < requestsByState.length; i++) {
      let descriptionAdded = false;
      countValidRequests += 1;

      for (let j = 0; j < descriptions.length; j++) {
        if (requestsByState[i].description === descriptions[j]) {
          descriptionAdded = true;
          quantities[j] = quantities[j] + 1;
        }
      }
      if (!descriptionAdded) {
        descriptions.push(requestsByState[i].description);
        quantities.push(1);
      }
      flowId[requestsByState[i].description] = requestsByState[i].flow_id;
    }

    //convert to object
    const requestItems = quantities.reduce(function (result, field, index) {
      result[descriptions[index]] = field;
      return result;
    }, {});

    return [requestItems, countValidRequests, flowId];
  };

  const getRequestItems = (requestValues, textColor, type, state, flowId) => {
    return (
      <div>
        {Object.keys(requestValues).map((description, index) => (
          <RequestItem
            key={description}
            description={description}
            num={Object.values(requestValues)[index]}
            textColor={textColor}
            allMenus={allMenus}
            type={type}
            t={t}
            state={state}
            flowId={flowId[description]}
          />
        ))}
      </div>
    );
  };

  if (Object.keys(requests).length > 0 && Array.isArray(requests)) {
    pendingRequestValues = processRequests(RequestState.PENDING);
    approvedRequestValues = processRequests(RequestState.APPROVED);
    refusedRequestValues = processRequests(RequestState.REJECTED);

    pendingRequests = getRequestItems(
      pendingRequestValues[0],
      "text-primary",
      "ped_ac_",
      RequestState.PENDING,
      pendingRequestValues[2]
    );
    approvedRequests = getRequestItems(
      approvedRequestValues[0],
      "text-secondary",
      "ped_ac_",
      RequestState.APPROVED,
      approvedRequestValues[2]
    );
    refusedRequests = getRequestItems(
      refusedRequestValues[0],
      "text-secondary",
      "ped_ac_",
      RequestState.REJECTED,
      refusedRequestValues[2]
    );

    nPendingRequests =
      pendingRequestValues[1] === 0 ? "" : pendingRequestValues[1];
  } else {
    pendingRequestValues = [];
    approvedRequestValues = [];
    refusedRequestValues = [];

    pendingRequests = (
      <div className="pl-3">{t("portalrh.requests.noRequests")}</div>
    );
    approvedRequests = (
      <div className="pl-3">{t("portalrh.requests.noRequests")}</div>
    );
    refusedRequests = (
      <div className="pl-3">{t("portalrh.requests.noRequests")}</div>
    );

    nPendingRequests = "";
  }

  return (
    <div className="main-card-v2">
      <Card bsPrefix="card-flat" style={{ padding: "25px 30px 10px 30px" }}>
        <Card.Header className="justify-content-between">
          <h6>
            <i className="icon-bell mr-2" />
            {t("MyRequestsWidget.title")}
          </h6>
          <CustomDropdown apagarWidget={apagarWidget} />
        </Card.Header>

        <Card.Body>
          {isLoadingRequests === "true" ? (
            <Spinner spinning={isLoadingRequests === "true"} />
          ) : (
            <Tabs
              className="custom-tabs"
              id="requestsTab"
              defaultActiveKey="first"
              activeKey={requestState}
              onSelect={(k) => setRequestState(k)}
            >
              <Tab
                mountOnEnter={true}
                className="scrollable"
                title={
                  <React.Fragment>
                    {t("portalrh.requests.pendingRequests") + " "}
                    <Badge pill className="text-white  bg-primary">
                      {nPendingRequests}
                    </Badge>
                  </React.Fragment>
                }
                eventKey={RequestState.PENDING}
              >
                {pendingRequests}
              </Tab>

              <Tab
                mountOnEnter={true}
                className="scrollable"
                title={
                  <React.Fragment>
                    {t("portalrh.requests.approvedRequests") + " "}
                  </React.Fragment>
                }
                eventKey={RequestState.APPROVED}
              >
                {approvedRequests}
              </Tab>

              <Tab
                mountOnEnter={true}
                className="scrollable"
                title={
                  <React.Fragment>
                    {t("portalrh.requests.refusedRequests") + " "}
                  </React.Fragment>
                }
                eventKey={RequestState.REJECTED}
              >
                <div className="scrollbar scrollbar-primary">
                  {refusedRequests}
                </div>
              </Tab>
            </Tabs>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default withNamespaces()(MyRequestsWidget);
